export const mensajesChat = {
  // NewConversationModal.vue — start a new WhatsApp conversation
  newConversation: {
    nameTooShort: "Geben Sie den Namen ein, unter dem Sie erkannt werden möchten.",
    saveNameError: "Der Firmenname konnte nicht gespeichert werden.",
    started: "Unterhaltung gestartet.",
    sent: "Nachricht gesendet.",
    startError: "Die Unterhaltung konnte nicht gestartet werden.",
    titleConnect: "Verbinden Sie Ihr WhatsApp",
    titleName: "Ihr Firmenname",
    titleNew: "Neue Unterhaltung",
    subtitleConnect: "Nötig, damit Sie zuerst schreiben können",
    subtitleName: "Unter diesem Namen sehen die Leute, von wem die Nachricht kommt",
    subtitleNew: "Schreiben Sie jeder Nummer auf WhatsApp",
    close: "Schließen",
    senderStripPre: "Wird gesendet als",
    change: "Ändern",
    connectBody:
      "Damit Sie zuerst schreiben können, muss die Nachricht von <strong>Ihrer eigenen WhatsApp-Business-Nummer</strong> kommen. Mit der geteilten Nummer von WACheckin würden die Leute eine fremde Rufnummer sehen, und wir könnten Sie nicht unter Ihrem Firmennamen vorstellen.",
    connectItem1: "Schreiben Sie jeder Nummer, mit oder ohne Buchung",
    connectItem2: "Ihr Firmenname erscheint als Absender",
    connectItem3: "Antworten landen in genau diesem Posteingang",
    connectFoot: "Einmal verbinden, unter Integrationen → WhatsApp.",
    previewLabel: "So sehen sie es",
    previewGreeting: "Hallo 👋",
    previewFromPre: "Wir schreiben Ihnen von",
    previewFromPost: ".",
    previewCtaPre: "Wir haben eine Nachricht für Sie. Antworten Sie",
    previewOk: "Ok",
    previewCtaPost: "und wir schicken sie Ihnen.",
    fallbackBusiness: "Ihrem Betrieb",
    nameLabel: "Firmenname",
    namePlaceholder: "Landhaus Sonnenaufgang",
    nameHelp:
      "Er wird unter KI-Agent → Neue Buchungen gespeichert und lässt sich dort oder hier jederzeit ändern.",
    recipientLabel: "Empfänger",
    messageLabel: "Nachricht",
    messagePlaceholder: "Schreiben Sie Ihre Nachricht…",
    cancelSoft: "Jetzt nicht",
    cancel: "Abbrechen",
    connectBtn: "WhatsApp verbinden",
    continueBtn: "Weiter",
    sendBtn: "Nachricht senden",
  },

  // MessageTranslate.vue — per-message translation in chat bubbles
  translate: {
    // BarraTraduccion.vue — die Übersetzerleiste des Chats (automatisch + Vorschau)
    off: "Automatische Übersetzung aus",
    on: "Übersetzt",
    turnOn: "Eingehendes übersetzen und Geschriebenes vorher ansehen",
    turnOff: "Automatische Übersetzung ausschalten",
    guestWrites: "der Gast schreibt auf {idioma}",
    nothingToDo: "Nichts zu übersetzen: der Gast schreibt auf {idioma}",
    youRead: "Sie lesen es auf",
    willBeSentIn: "was Sie schreiben, geht raus auf",
    pickOutgoing: "In welcher Sprache es bei ihm ankommt",
    theirs: "seine",
    willArriveAs: "So kommt es an, auf {idioma}:",
    sendIn: "Auf {idioma} senden",
    cancel: "Abbrechen",
    discard: "Verwerfen",
    enterSends: "Mit Enter geht es raus",
    translating: "Wird übersetzt…",
    translate: "Übersetzen",
    viewTranslation: "Übersetzung anzeigen",
    viewOriginal: "Original anzeigen",
    translated: "Übersetzt",
    copy: "Kopieren",
    copied: "Kopiert",
    error: "Übersetzung nicht möglich. Bitte erneut versuchen.",
  },

  // Phone.vue — WhatsApp-style chatbot preview
  phone: {
    online: "Online",
    today: "Heute",
    sampleQuestion: "Wann ist der Check-in?",
    answerPlaceholder: "Schreiben Sie hier Ihre Antwort...",
    inputPlaceholder: "Nachricht schreiben...",
  },

  // selectorTypeIframe.vue — subscription billing period selector
  billing: {
    selectPeriod: "Zeitraum wählen",
    selectPeriodHint: "Wählen Sie, wie Sie zahlen möchten",
    monthly: "Monatlich",
    annual: "Jährlich",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "An wen Sie schreiben",
    modeOne: "Einzelne Nachricht",
    modeGroup: "Sammelnachricht",
    allOtas: "Alle",
    needsWhatsapp: "Verbinden Sie Ihr WhatsApp, um diesen Weg zu nutzen",
    connectNow: "Verbinden",
    varsLabel: "Variable",
    vars: {
      nombre: "Der Name des Gastes",
      alojamiento: "Der Name der Unterkunft",
      entrada: "Das Anreisedatum",
      salida: "Das Abreisedatum",
      codigo: "Der Buchungscode",
    },
    remove: "Entfernen",
    oneEach: "Jeder Gast erhält es einmal, über den ersten verfügbaren Weg.",
    noContact: "1 ohne Kontaktmöglichkeit | {count} ohne Kontaktmöglichkeit",
    otaLabel: "Welche OTA",
    emoji: "Emoji",
    attach: "Datei anhängen",
    noFileOta: "Die Datei geht nicht über die OTA",
    previewLabel: "So wird es gelesen",
    fileTooBig: "„{name}“ ist {size} MB groß; WhatsApp erlaubt für diesen Typ höchstens {max} MB",
    fileNotAllowed: "Erlaubt sind nur Bilder (JPG, PNG, GIF), PDF und MP4-Video: Andere Formate spielt WhatsApp nicht ab.",
    attachHint: "Bilder und PDF bis 10 MB · MP4-Video bis 15 MB",
    channelLabel: "Über welchen Weg",
    channels: { whatsapp: "WhatsApp", email: "E-Mail", ota: "OTA" },
    groupLabel: "Welche Gäste",
    groups: {
      alojados: "Derzeit im Haus",
      entran_hoy: "Reisen heute an",
      entran: "Reisen bald an",
      salen: "Reisen heute ab",
    },
    withinPre: "in den nächsten",
    withinPost: "Tag | Tagen",
    empty: "Derzeit keine Gäste in dieser Gruppe.",
    reachOf: "von {total} erhält sie | von {total} erhalten sie",
    queuedSilently: "1 erhält heute keine Benachrichtigung: es war bereits eine offen | {count} erhalten heute keine Benachrichtigung: es war bereits eine offen",
    noChannel: {
      whatsapp: "1 ohne Telefon | {count} ohne Telefon",
      email: "1 ohne E-Mail | {count} ohne E-Mail",
      ota: "1 ohne OTA-Verlauf | {count} ohne OTA-Verlauf",
    },
    billed: "1 WhatsApp-Konversation wird berechnet | {count} WhatsApp-Konversationen werden berechnet",
    showList: "Empfänger anzeigen | Alle {count} Empfänger anzeigen",
    hideList: "Liste ausblenden",
    noName: "Ohne Namen",
    states: {
      directo: "zugestellt",
      plantilla: "Einladung",
      en_cola: "hatte bereits eine offen",
      sin_telefono: "ohne Telefon",
      sin_correo: "ohne E-Mail",
      sin_hilo_ota: "ohne Verlauf",
      sin_contacto: "kein Kontakt",
    },
    sending: "Senden an 1 Gast | Senden an {count} Gäste",
    sendGroup: "An 1 Gast senden | An {count} Gäste senden",
    historial: {
      providerId: "Kennung beim Anbieter. Damit lässt sich die Nachricht in der SES-Konsole finden.",
      sentMeans: "„Gesendet“ heißt, der Anbieter hat sie angenommen. Ob der Gast sie liest oder sie im Spam landet, liegt nicht mehr bei uns.",
      estados: {
        enviando: "Wird gesendet",
        enviado: "Gesendet",
        en_cola: "In Warteschlange",
        fallo: "Fehlgeschlagen",
        sin_contacto: "Keine Kontaktdaten",
      },
      title: "Sammelnachrichten",
      subtitle: "Was gesendet wurde, an wen und was damit passiert ist",
      empty: "Sie haben noch keine Sammelnachricht gesendet.",
      error: "Der Verlauf konnte nicht geladen werden.",
      sentBy: "von {quien}",
      running: "Läuft",
      back: "Zurück",
      messageLabel: "Die Nachricht",
      recipientsLabel: "Empfänger",
      colName: "Gast",
      colVia: "Kanal",
      colDest: "Gesendet an",
      colState: "Ergebnis",
      openChat: "Öffnen",
      attachment: "Anhang: {nombre}",
      close: "Schließen",
      reached: "{enviados} von {total}",
      noOne: "Ohne Namen",
    },
  },
};
